import { createClient } from '@supabase/supabase-js'

// Supabase configuration
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.')
}

// Get the current site URL for redirects
const getURL = () => {
  let url = 
    import.meta.env.VITE_SITE_URL ?? // Set this in Netlify env vars
    import.meta.env.VITE_VERCEL_URL ?? // Automatically set by Vercel
    'http://localhost:5173' // Default for development

  // Make sure to include `https://` when not localhost
  url = url.includes('http') ? url : `https://${url}`
  // Remove trailing slash
  url = url.charAt(url.length - 1) === '/' ? url.slice(0, -1) : url
  return url
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Export the URL helper for use in auth methods
export { getURL }

// Database types (will be auto-generated later)
export interface Database {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string
          username: string
          avatar: string
          created_at: string
          last_active_at: string
          stats: any // JSONB
          preferences: any // JSONB
        }
        Insert: {
          id: string
          username: string
          avatar: string
          created_at?: string
          last_active_at?: string
          stats?: any
          preferences?: any
        }
        Update: {
          id?: string
          username?: string
          avatar?: string
          created_at?: string
          last_active_at?: string
          stats?: any
          preferences?: any
        }
      }
      game_sessions: {
        Row: {
          id: string
          user_id: string
          game_mode: string
          difficulty: string
          measurement_type: string | null
          score: number
          questions_answered: number
          correct_answers: number
          streak: number
          time_played: number
          started_at: string
          completed_at: string
          created_at: string
        }
        Insert: {
          id?: string
          user_id: string
          game_mode: string
          difficulty: string
          measurement_type?: string | null
          score: number
          questions_answered: number
          correct_answers: number
          streak: number
          time_played: number
          started_at: string
          completed_at: string
          created_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          game_mode?: string
          difficulty?: string
          measurement_type?: string | null
          score?: number
          questions_answered?: number
          correct_answers?: number
          streak?: number
          time_played?: number
          started_at?: string
          completed_at?: string
          created_at?: string
        }
      }
      user_achievements: {
        Row: {
          user_id: string
          achievement_id: string
          unlocked_at: string
          progress: number | null
        }
        Insert: {
          user_id: string
          achievement_id: string
          unlocked_at?: string
          progress?: number | null
        }
        Update: {
          user_id?: string
          achievement_id?: string
          unlocked_at?: string
          progress?: number | null
        }
      }
    }
  }
} 